var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentFile,{tag:"component",attrs:{"component":_vm.component,"preview":_vm.preview,"id":_vm.component.domId}})}
var staticRenderFns = []

export { render, staticRenderFns }